import { authApi } from '@/features/auth/auth.api.ts'
import { unauthorizedMiddleware } from '@/redux/unauthorized.middleware.ts'
import { authPersistenceMiddleware } from '@/features/auth/auth.middleware.ts'
import { invoicesAllocationApi } from '@/pages/invoices-allocation/api'
import { deferredBonusesApi } from '@/pages/deferred-bonuses/api'
import { agGridStateApi } from '@/features/ag-grid-state/ag-grid-state.api.ts'
import { userMessagesApi } from '@/features/user-messages/user-messages.api.ts'

export const extraMiddleware = [
  authPersistenceMiddleware,
  unauthorizedMiddleware,
  authApi.middleware,
  invoicesAllocationApi.middleware,
  deferredBonusesApi.middleware,
  agGridStateApi.middleware,
  userMessagesApi.middleware,
]
